import { TextFormatItalics16 } from 'ui/icons/aurora/16px/TextFormatItalics16';
import { useFormattingContext } from '../contexts/formatting';
import { BaseToolbarButton } from './BaseToolbarButton';
import { useTranslation } from '../../../../../hooks/useTranslation';

export const ToggleItalicButton = () => {
  const { t } = useTranslation();
  const { isItalicEnabled, toggleItalic } = useFormattingContext();
  return (
    <BaseToolbarButton
      isSelected={isItalicEnabled}
      onClick={toggleItalic}
      tooltip={t('contentPicker.textEditor.italic')}
      data-test="italic-button"
    >
      <TextFormatItalics16 isColorInherited />
    </BaseToolbarButton>
  );
};
